module.exports = __webpack_public_path__ + "assets/images/logo-coderslab-en.png";